import { InjectionToken } from '@angular/core';
import { PlatformType } from '@data-access';

export const CABINET_TYPE = new InjectionToken<PlatformType>('CABINET_TYPE');
